import { number_format } from '@/api/filter';
export const config = {
  data() {
    return {
      columns: [],
      searchParams: {
        dateType: '1',
        orderType: '1'
      }
    };
  },
  methods: {
    getColumns() {
      let statusMap = {
        '-20': '批改失败',
        '-15': '核保失败',
        '0': '待提交',
        '20': '待支付/确认',
        '30': '待实收',
        '40': '待承保',
        '50': '已完成',
        '-99': '已撤销',
        '-9': '已失效'
      };
      let typeMap = {
        '1': '增保',
        '2': '替保',
        '3': '减保'
      };
      this.columns = [
        {
          title: '创建时间',
          key: 'createTime',
          minWidth: 160,
          align: 'center',
          render(h, params) {
            let createTime = params.row.createTime.substring(0, 16);
            return <span>{createTime}</span>;
          }
        },
        {
          title: '保单号/批单号',
          slot: 'orderNo',
          minWidth: 200,
          align: 'center',
        },
        {
          title: '产品名称',
          key: 'productName',
          minWidth: 230,
          align: 'center'
        },
        {
          title: '投保人',
          key: 'holderName',
          minWidth: 180,
          align: 'center'
        },
        {
          title: '批单生效日期',
          key: 'startTime',
          minWidth: 180,
          align: 'center',
          render(h, params) {
            let startTime = params.row.startTime.substring(0, 10);
            return <span>{startTime}</span>;
          }
        },
        {
          title: '保费（元）',
          key: 'fee',
          minWidth: 140,
          align: 'center',
          render(h, params) {
            return <span> {number_format(params.row.fee, 2)}</span>;
          }
        },
        {
          title: '变更类型',
          key: 'type',
          minWidth: 140,
          align: 'center',
          render(h, params) {
            return <span> {typeMap[params.row.type]}</span>;
          }
        },
        {
          title: '服务费（元）',
          key: 'commission',
          minWidth: 140,
          align: 'center',
          render(h, params) {
            return <span> {number_format(params.row.commission, 2)}</span>;
          }
        },
        {
          title: '状态',
          key: 'status',
          minWidth: 140,
          align: 'center',
          render(h, params) {
            return <span> {statusMap[params.row.status]}</span>;
          }
        },
        {
          title: '业务员',
          key: 'salemanName',
          minWidth: 180,
          align: 'center',
          render(h, params) {
            return (
              <span>
                {params.row.staffNo} /{params.row.salemanName}
              </span>
            );
          }
        },
        {
          title: '所属团队',
          key: 'groupName',
          minWidth: 200,
          align: 'center',
          render(h, params) {
            return (
              <span>
                {params.row.organizationName} /{params.row.groupName}
              </span>
            );
          }
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: '180',
          fixed: 'right'
        }
      ];
    }
  }
};
